import type { ReactElement, Ref } from 'react';
import { forwardRef } from 'react';
import type { UseControllerProps } from 'react-hook-form';
import { useController, useFormContext } from 'react-hook-form';

import { Select } from '@seuk/design-system/molecules';

interface SelectItem {
  value: string;
  label: string;
}

export interface ControlledSelectProps {
  name: string;
  rules?: UseControllerProps['rules'];
  className?: string;
  isLoading?: boolean;
  id: string;
  items: SelectItem[];
  disabled?: boolean;
  placeholderItem?: SelectItem;
  label?: string;
  'data-testid'?: string;
}

const ControlledSelect = forwardRef(function ControlledSelect(
  { id, name, rules, isLoading, items, disabled, placeholderItem, label, className, ...props }: ControlledSelectProps,
  ref: Ref<HTMLSelectElement>
): ReactElement {
  const { control } = useFormContext();
  const {
    field,
    fieldState: { error },
  } = useController({ name, control, rules });

  return (
    <Select
      isLoading={isLoading}
      id={id}
      data-testid={props['data-testid'] ?? 'controlled-select'}
      label={label}
      items={items}
      disabled={disabled}
      placeholderItem={placeholderItem}
      error={error}
      className={className}
      {...field}
      ref={ref}
    />
  );
});

export { ControlledSelect };
